import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingIndicatorModule } from '@core-mkt/shared/components/loading-indicator/loading-indicator.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { VisionSelectComponent } from './vision-select/vision-select.component';

@NgModule({
  exports: [VisionSelectComponent],
  imports: [CommonModule, FontAwesomeModule, LoadingIndicatorModule, VisionSelectComponent],
})
export class VisionSelectModule {}
